import { DateTime } from "luxon";

export function morningstarFormDefaults(morningstar) {
  const stored = morningstar || {};
  return {
    "morningstar-manual": Boolean(stored.manual),
    "morningstar-rating":
      stored.rating === null || stored.rating === undefined
        ? ""
        : String(stored.rating),
    "morningstar-category": stored.category || "",
    "morningstar-ratingdate": stored.rating_date
      ? DateTime.fromISO(stored.rating_date).toJSDate()
      : null,
  };
}

export function buildMorningstarBody(formValues) {
  if (!formValues["morningstar-manual"]) {
    return { manual: false };
  }
  const rating = formValues["morningstar-rating"];
  const ratingDate = formValues["morningstar-ratingdate"];
  return {
    manual: true,
    rating:
      rating === undefined || rating === null || rating === ""
        ? null
        : Number(rating),
    category: (formValues["morningstar-category"] || "").trim() || null,
    rating_date: ratingDate
      ? DateTime.fromJSDate(new Date(ratingDate)).toFormat("yyyy-MM-dd")
      : null,
  };
}

// Omitting the key leaves the stored override alone, so a save that never
// touched this tab cannot release or overwrite another admin's lock.
export function morningstarChange(formValues, stored) {
  const body = buildMorningstarBody(formValues);
  const unchanged = buildMorningstarBody(morningstarFormDefaults(stored));
  return JSON.stringify(body) === JSON.stringify(unchanged) ? undefined : body;
}

const OVERRIDE_LABELS = {
  "morningstar-rating": "Rating",
  "morningstar-category": "Category",
  "morningstar-ratingdate": "Rating Date",
};
const CATEGORY_MAX = 100;

// Validates only what the save will send. Untouched, the key is omitted, so a
// legacy lock with empty values still saves unrelated edits. Unticked, the
// inputs are locked to the NAV sync and nothing is required. "Not rated" ("")
// counts as empty on a ticked override.
export function morningstarFieldError(name, formValues, stored) {
  const body = morningstarChange(formValues, stored);
  if (!body || !body.manual) return null;
  const value = formValues[name];
  const text = typeof value === "string" ? value.trim() : value;
  if (text === "" || text === null || text === undefined) {
    return `${OVERRIDE_LABELS[name]} is required while Override is ticked.`;
  }
  if (name === "morningstar-category" && text.length > CATEGORY_MAX) {
    return `Category must be ${CATEGORY_MAX} characters or fewer.`;
  }
  return null;
}
